<template>
  <dl class="flex flex-col gap-y-3">
    <slot />
  </dl>
</template>
